import { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { Box, Typography, LinearProgress, Grid } from '@mui/material';
import { ILoadingBarStoreProps } from './LoadingBarConnector';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import { Environment } from '../../Global/Environment';
import { OutlinedButton } from '@mvf/product-components';

type LoadingBarType = FunctionComponent<ILoadingBarStoreProps>;
export const LoadingBar: LoadingBarType = ({
  location,
  redirectUrl,
  manuallyRedirect,
}) => {
  const [range] = useState(() => {
    const min = new Date().getTime();
    const max = min + Environment.MAX_DURATION_SECONDS * 1000;

    return { min, max };
  });

  const [progress, setProgress] = useState(range.min);

  useEffect(() => {
    const interval = setInterval(() => {
      const timestamp = new Date().getTime();
      const x = timestamp - 500;
      const y = timestamp + 500;

      const newProgress = Math.random() * (y - x) + x;

      setProgress(newProgress > range.max ? range.max : newProgress);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const normalise = (value: number) =>
    ((value - range.min) * 100) / (range.max - range.min);

  const isDone = redirectUrl != undefined || location.hash === '#bypass';

  const icon =
    isDone || normalise(progress) > 90 ? (
      <VerifiedUserIcon color="success" sx={{ height: '100%', fontSize: 40 }} />
    ) : (
      <EmojiPeopleIcon color="primary" sx={{ height: '100%', fontSize: 40 }} />
    );

  const messages = [
    "Verifying you're human...",
    "Verifying you're human...",
    "Verifying you're human...",
    "Verifying you're human...",
    "Verifying you're human...",
    'Processing your request...',
    'Processing your request...',
    'Processing your request...',
    'Processing your request...',
    'Almost there...',
    'Almost there...',
  ];

  let message = isDone
    ? 'Almost there...'
    : messages[Math.floor(normalise(progress) / 10)];

  const progressBar = isDone ? (
    <LinearProgress />
  ) : (
    <LinearProgress
      variant="determinate"
      value={normalise(progress)}
      sx={{
        '& .MuiLinearProgress-bar': {
          transition: 'transform 1s ease-out',
        },
      }}
    />
  );

  let progressBarOrButton = <Box width="100%">{progressBar}</Box>;

  const isLocationOnDoneState = ['#done', '#bypass'].includes(location.hash);
  if (isLocationOnDoneState && redirectUrl != undefined) {
    message = 'Your redirect was cancelled';
    progressBarOrButton = (
      <OutlinedButton onClick={() => manuallyRedirect(redirectUrl)}>
        Proceed Manually
      </OutlinedButton>
    );
  }

  return (
    <Fragment>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        paddingX={2}
      >
        <Grid display="flex" flexDirection="row" width="100vw" maxWidth={400}>
          <Grid paddingX={1}>{icon}</Grid>
          <Grid flexGrow={1} paddingRight={1}>
            <Typography width="100%" variant="h5" gutterBottom>
              {message}
            </Typography>
            {progressBarOrButton}
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  );
};
